import React from 'react';
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { NoStyleButton } from '@vio/atlas/helpers/NoStyleButton';
import { Icon } from '@vio/atlas/Icon';
import { UserAvatar } from '@vio/shared/src/user/account/UserAvatar';
import { User } from '@daedalus/core/src/auth/types/Cognito';
const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "wrpa7qy",
  propsAsIs: false
});
interface Props {
  onShowPreferences?: () => void;
  shouldShowUserAvatar: boolean;
  user?: User;
  hasWhiteTheme?: boolean; // Added as part of 1c5ad789-mobile-top-bar
}
export const MobileHeaderMenu = ({
  onShowPreferences,
  shouldShowUserAvatar,
  user,
  hasWhiteTheme = false
}: Props) => {
  return <Wrapper className={cx(hasWhiteTheme && '__hasWhiteTheme')}>
      <NoStyleButton onClick={onShowPreferences} data-id="ShowPreferencesButton" data-testid="ShowPreferencesButton">
        {shouldShowUserAvatar && user ? <UserAvatar user={user} className="__mobileHeaderAvatar" /> : <Icon name="Menu" size="md" />}
      </NoStyleButton>
    </Wrapper>;
};

require("./MobileHeaderMenu.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./MobileHeaderMenu.tsx");